import { useEffect, useState } from "react";
import { Headphones, Loader2, Trophy, Volume2 } from "lucide-react";
import { api } from "@/lib/api";
import { ListenBoard } from "@/components/news/ListenBoard";

export const ListenStreak = ({ onListen, busy = false, refreshKey = 0 }) => {
  const [run, setRun] = useState(null);
  const [board, setBoard] = useState(false);

  useEffect(() => {
    api.get("/news/listen-streak").then(({ data }) => setRun(data)).catch(() => {});
  }, [refreshKey]);

  if (!run) return null;

  const nudge = run.next && run.next.remaining > 0
    ? `${run.next.remaining} more day${run.next.remaining === 1 ? "" : "s"} for ${run.next.badge}`
    : "";

  return (
    <div className="mt-2">
    <p className="flex flex-wrap items-center gap-2 rounded-full border border-white/10 bg-panel px-3 py-1.5 text-xs"
       data-testid="news-listen-streak">
      <Headphones className={`h-3.5 w-3.5 ${run.today ? "text-emerald-300" : "text-ink-soft"}`} />
      {run.days > 0 ? (
        <span data-testid="listen-streak-days">
          <span className="font-semibold">{run.days} day{run.days === 1 ? "" : "s"}</span> of listening
          {run.today ? "" : " — one listen keeps it going"}
          {run.best > run.days ? ` · best ${run.best}` : ""}
        </span>
      ) : (
        <span className="text-ink-soft" data-testid="listen-streak-empty">
          Hear one story to start a listening run
        </span>
      )}
      {nudge && <span className="text-ink-soft" data-testid="listen-streak-next">· {nudge}</span>}
      {run.badges?.map((b) => (
        <span key={b} data-testid={`listen-badge-${b.replace(/\s+/g, "-").toLowerCase()}`}
              className="rounded-full border border-brand/40 px-2 py-0.5 text-[10px] font-semibold text-brand">
          {b}
        </span>
      ))}
      {!run.today && onListen && (
        <button
          data-testid="listen-streak-play"
          onClick={onListen}
          disabled={busy}
          className="inline-flex items-center gap-1 rounded-full bg-brand px-2.5 py-0.5 text-[11px] font-semibold text-white transition-colors hover:bg-brand-hover active:scale-95 disabled:opacity-50"
        >
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Volume2 className="h-3 w-3" />} Listen
        </button>
      )}
      <button
        data-testid="listen-streak-compare"
        onClick={() => setBoard((v) => !v)}
        className="inline-flex items-center gap-1 text-[11px] text-ink-soft underline decoration-dotted transition-colors hover:text-brand"
      >
        <Trophy className="h-3 w-3" /> {board ? "Hide friends" : "Compare with friends"}
      </button>
    </p>
    {board && <ListenBoard onClose={() => setBoard(false)} />}
    </div>
  );
};
